import { InputRule } from 'prosemirror-inputrules';
import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import plugins from './plugins';

export { LINK_ELEMENT_CLASS } from './plugins';

const LINK_NODE_NAME = 'link';
const LINK_INPUT_REGEX = /\[([^[]+)]\((\S+)\)$/;

export default class Link extends BaseExtension {
  get schema(): MarkSpec {
    return {
      attrs: {
        href: {
          default: '',
        },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: (dom: any) => {
            return {
              href: dom.getAttribute('href'),
            };
          },
        },
      ],
      toDOM: (node) => [
        'a',
        {
          ...node.attrs,
          target: '_blank',
          title: node.attrs.href,
          rel: 'noopener noreferrer nofollow',
          class: 'cursor-pointer text-bg-accent hover:underline link-element',
        },
        0,
      ],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return LINK_NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      mark: LINK_NODE_NAME,
      getAttrs: (tok: any) => {
        return {
          href: tok.attrGet('href'),
        };
      },
    };
  }

  inputRules({ schema }: EditorOptions) {
    return [
      new InputRule(LINK_INPUT_REGEX, (state, match, start, end) => {
        const [okay, alt, href] = match;
        const { tr } = state;

        if (okay) {
          tr.replaceWith(start, end, schema.text(alt)).addMark(
            start,
            start + alt.length,
            schema.marks.link.create({ href }),
          );
        }

        return tr;
      }),
    ];
  }

  plugins = plugins;
}
